/** Root of the platform area. Being under it is what puts the SPA in platform mode. */
export const PLATFORM_ROOT = '/plataforma'

/** Shown after login to people who are both a client user and a platform administrator. */
export const MODE_SELECTOR_PATH = '/seleccionar-modo'

export const isPlatformPath = (pathname: string) =>
  pathname === PLATFORM_ROOT || pathname.startsWith(`${PLATFORM_ROOT}/`)
